import { HttpBackend, HttpClient, HttpHeaders, HttpParams, HttpRequest, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ServiceBase } from '@app/shared/services';
import { Profilemodel } from '../models/profile.model';
import { Observable, filter, map, of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfileService extends ServiceBase<any> {
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  constructor(protected http: HttpClient, @Inject('BASE_URL') baseUrl: string, private httpBackend: HttpBackend) {
    super(http, baseUrl, 'api/Account');
  }

  getProfile() {
    return this.http.get<Profilemodel>(this.baseUrl + '/profile', {
      headers: this.headers,
    });
  }

  passwordChange(oldPassword: string, password: string, confirmPassword: string) {
    let data = {
      oldPassword: oldPassword,
      newPassword: password,
      newPasswordConfirm: confirmPassword,
    };
    return this.http.put<any>(this.baseUrl + '/changepassword', data, {
      headers: this.headers,
    });
  }

  getTheme(thmId?: number): Observable<any> {
    let themes = null;
    return this.httpBackend.handle(
      new HttpRequest("GET", `${this.baseUrl}/theme`, null, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: thmId ? new HttpParams({ fromObject: { thmId } }) : null
      })
    ).pipe(
      filter(event => event && event.type !== 0),
      tap((response: HttpResponse<any>) => {
        themes = response.body;
      }),
      map(_ => themes),
    );;
  }

  updateDefaultTheme(thmId: number, isDarkTheme: boolean): Observable<any> {
    return this.http.put<any>(this.baseUrl + '/theme', null, {
      headers: this.headers,
      params: { thmId, isDarkTheme }
    });
  }
}
